import { render, staticRenderFns } from "./CreateRER.vue?vue&type=template&id=1e6b0c48&scoped=true&"
import script from "./CreateRER.vue?vue&type=script&lang=ts&"
export * from "./CreateRER.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRER.vue?vue&type=style&index=0&id=1e6b0c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6b0c48",
  null
  
)

export default component.exports